import { Box, Stack, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import PropTypes from 'prop-types';
import { cloneElement, isValidElement } from 'react';

const EmptyState = ({ icon, title, description, action, dense = false }) => {
  const renderedIcon = icon
    ? isValidElement(icon)
      ? cloneElement(icon, {
          sx: { fontSize: dense ? 32 : 56, color: 'text.disabled', ...(icon.props?.sx || {}) },
        })
      : icon
    : <InboxOutlinedIcon sx={{ fontSize: dense ? 32 : 56, color: 'text.disabled' }} />;

  return (
    <Box
      sx={{
        py: dense ? 3 : 6,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Stack spacing={dense ? 1 : 1.5} alignItems="center">
        {renderedIcon}
        <Typography variant={dense ? 'body2' : 'subtitle1'} sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
            {description}
          </Typography>
        )}
        {action && <Box sx={{ mt: 1 }}>{action}</Box>}
      </Stack>
    </Box>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  dense: PropTypes.bool,
};

export default EmptyState;
